/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseFile } from './BaseFile';
const AutoTestFixtureParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([['hidden', codecBoolean]]), BaseFile);
export class AutoTestFixture extends BaseFile {
    static decode(input) {
        return AutoTestFixtureParser.decode(input).map(res => new AutoTestFixture(res));
    }
    static unsafeDecode(input) {
        return AutoTestFixture.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestFixtureParser.encode(data);
    }
    static schema() {
        return AutoTestFixtureParser.schema();
    }
}
